import { Link } from 'react-router-dom';

const categories_1 = ["Home", "Shorts", "Videos", "Live"];
const categories_2 = ["Sports", "Games", "Movies", "Music"];

const Sidebar = () => {
  return (
    <>
      {/* Mobile backdrop overlay — clicking closes sidebar */}
      <label htmlFor="sidebar-toggle" className="sidebar-backdrop" />

      {/* Sidebar content */}
      <div className="sidebar-wrapper w-48 bg-white shadow-xl pt-14 px-2 h-auto max-h-screen overflow-y-auto
                      md:w-auto md:shadow-lg md:pt-0 md:m-5 md:max-h-none md:flex-shrink-0 md:min-w-fit md:self-start">

        <div className="rounded-lg p-2 md:shadow-none">
          <h1 className="font-bold px-2 mb-2 text-left">Subscriptions</h1>
          <ul className="space-y-1">
            {categories_1.map((category) => (
              <li key={category}>
                <label htmlFor="sidebar-toggle" className="md:contents">
                  <Link
                    to={`/search?q=${encodeURIComponent(category)}`}
                    className="block px-4 py-2 hover:bg-gray-100 rounded-lg text-sm md:text-base"
                  >{category}</Link>
                </label>
              </li>
            ))}
          </ul>
          <h1 className="font-bold px-2 mb-2 mt-4 text-left">Watch later</h1>
          <ul className="space-y-1">
            {categories_2.map((category) => (
              <li key={category}>
                <label htmlFor="sidebar-toggle" className="md:contents">
                  <Link
                    to={`/search?q=${encodeURIComponent(category)}`}
                    className="block px-4 py-2 hover:bg-gray-100 rounded-lg text-sm md:text-base"
                  >{category}</Link>
                </label>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  )
}

export default Sidebar